module.exports = __webpack_public_path__ + "img/COM-A-2-III.63431070.png";